
function undefinedToNull(obj){
  return typeof obj !== 'undefined' ? obj : null
}

export const formatted_posts =(blogposts)=>{
  return blogposts && blogposts.map((blog,i)=>{
    if(!blog.fields) return;

    const {
      author,
      body,
      heroImage,
      publishDate,
      slug,
      tags,
      embedCodes,
      title} = blog.fields;

    let item = {
      id: i+1,
      publishDate: undefinedToNull(publishDate),
      embedCodes: undefinedToNull(embedCodes),
      slug: undefinedToNull(slug),
      tags: undefinedToNull(tags),
      title: undefinedToNull(title),
      body: undefinedToNull(body)
    };

    if(author && author.fields && author.fields.name) item.author = author.fields.name;
    if(heroImage && heroImage.fields && heroImage.fields.file && heroImage.fields.file.url){
      item.coverImage = heroImage.fields.file.url;
      item.thumbImage = heroImage.fields.file.url;
    }
    return item;
  })
}

export const formatted_persons =(blogposts)=>{
  return blogposts && blogposts.map((blog,i)=>{
    if(!blog.fields) return;
    const {
        name,
        image,
        shortBio,
        email,
        phone,
        facebook,
        twitter,
      publishDate
    } = blog.fields;

    let item = {id:i+1,
      name: undefinedToNull(name),
      publishDate: undefinedToNull(publishDate),
      shortBio: undefinedToNull(shortBio),
      email: undefinedToNull(email),
      phone: undefinedToNull(phone),
      facebook: undefinedToNull(facebook),
      twitter: undefinedToNull(twitter),
    };

    if(image && image.fields && image.fields.file && image.fields.file.url){
      item.image = image.fields.file.url;
    }

    return item;
  })
}

